module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/next-aa3805d3722da857dd5b1399d04d400b.svg";